import React from "react";
import Title from "../components/TitleComponent";
import { Row, Col} from "react-bootstrap";
import Details from "../components/DetailsComponent";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Helmet } from "react-helmet-async";
import CarouselComp from "../components/CarouselComponent";

export default function ActivityPage() {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 1200 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 1199, min: 992 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 991, min: 700 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 700, min: 0 },
      items: 1,
    },
  };

  const intro = "Ne propunem sa dezvoltam proiecte cu privire la educatia psiho-emotionala a copiilor si a parintilor, campanii de identificare a tulburarilor de dezvoltare si a tulburarilor de invatare, ateliere si workshopuri de dezvoltare si optimizare personala pentru adolescenti si adulti, ateliere si demersuri specifice de psihoeducatie."

  return (
    <>
      <Helmet>
        <title>Activitate</title>
        <meta
          name="description"
          content="Ne propunem sa dezvoltam proiecte cu privire la educatia psiho-emotionala a copiilor si a parintilor, campanii de identificare a tulburarilor de dezvoltare si de invatare, ateliere de dezvoltare personala pentru adolescenti si adulti, ateliere si demersuri specifice de psihoeducatie, terapii de recuperare, consiliere psihologica copii, adolescenti, adulti, logopedie."
        />
        <link rel="canonical" href="https://www.psinapsis.ro/activity" />
      </Helmet>

      <Row className="p-0 m-0">
        <Col className="d-none d-xl-block"></Col>
        <Col className="whiteBg p-0 m-0 min-xl-screen-size">
          <Title title="" />
          <Details normalText={intro} />
          <div className="pb-4"></div>
          
          <Carousel
            fade
            swipeable={true}
            ssr={true} // means to render carousel on server-side.
            infinite={true}
            keyBoardControl={true}
            customTransition="all .1"
            transitionDuration={500}
            containerClass="carousel-container"
            dotListClass="custom-dot-list-style"
            itemClass="carouselItem"
            responsive={responsive}
          >
            <CarouselComp 
              photo="/images/Event 2 aprilie.jpeg"
              alt="Ziua Internationala de Constientizare a Autismului"
              goTo="/events/autismday2026"
              titluArticol="Ziua Internationala de Constientizare a Autismului"
              dataEvent="2 aprilie 2026"
            />

            <CarouselComp 
              photo="/images/tabara2.jpeg"
              alt="Prima tabara pentru copiii cu autism"
              goTo="/events/camp_retrospective"
              titluArticol="Am ajuns la mare…  Retrospectiva primei tabere pentru copiii cu autism"
              dataEvent="30 august - 5 septembrie 2025"
            />      

            <CarouselComp 
              photo="/images/event cover.jpg"
              alt="Retreat"
              goTo="/events/retreatevent"
              titluArticol="Retreat destinat specialistilor in terapia de recuperare"
              dataEvent="22-24 august 2025"
            /> 

            <CarouselComp 
              photo="/images/arta.png"
              alt="Ateliere de art-terapie"
              goTo="/events/arttherapyevent"
              titluArticol="Ateliere de art-terapie"
              dataEvent="februarie - martie 2025"
            />           

             <CarouselComp 
              photo="/images/tabara terapeutica 3.jpg"
              alt="Tabara terapeutica pentru copii cu autism"
              goTo="/events/therapeuticcamp"
              titluArticol="Tabara terapeutica pentru copii cu autism"
              dataEvent="2025"
            />     

            <CarouselComp 
              photo="/images/workshop.jpg"
              alt="Integrare senzoriala"
              goTo="/events/workshopevent"
              titluArticol="Workshop - Integrarea Senzoriala"
              dataEvent="5 octombrie 2024"
            />

            <CarouselComp 
              photo="/images/brosura2.png"
              alt="Lansare brosura autism, ghid pentru parinti realizat de Calinescu Diana"
              goTo="/events/autismdayevent"
              titluArticol="Ziua Internationala de Constientizare a Autismului - Lansarea brosurii pentru parinti"
              dataEvent="2 aprilie 2024"
            />
            
            <CarouselComp
              photo="/images/sala_terapieR.jpg"
              alt="Asociatia PsiNapsis organizeaza un grup cu participare gratuita pentru copiii cu TSA"
              goTo="/events/tsaevent"
              titluArticol="Grup cu participare gratuita pentru copiii cu TSA"
              dataEvent="februarie - mai 2024"
            />

            <CarouselComp
              photo="/images/dislexieR.jpg"
              alt="Evaluarea dislexiei si a disortografiei de dezvoltare in cadrul Asociatiei PsiNapsis"
              goTo="/events/evdislexieevent"
              titluArticol="Evaluarea dislexiei si a disortografiei de dezvoltare"
              dataEvent="1 - 2 iunie 2023"
            />
          </Carousel>

          <Title title="Articole" />
          <Carousel
            fade
            swipeable={true}
            ssr={true} // means to render carousel on server-side.
            infinite={true}
            keyBoardControl={true}
            customTransition="all .5"
            transitionDuration={500}
            containerClass="carousel-container"
            dotListClass="custom-dot-list-style"
            itemClass="carouselItem"
            responsive={responsive}
          >

            <CarouselComp
              photo="/images/psiholog vs psihiatru_sm.png"
              alt="Evaluare psihologica vs evaluare psihiatrica in tulburarile de dezvoltare"
              goTo="/articles/psychologypsychiatryarticle"
              titluArticol="𝗘𝘃𝗮𝗹𝘂𝗮𝗿𝗲 𝗽𝘀𝗶𝗵𝗼𝗹𝗼𝗴𝗶𝗰𝗮 𝘃𝘀 𝗲𝘃𝗮𝗹𝘂𝗮𝗿𝗲 𝗽𝘀𝗶𝗵𝗶𝗮𝘁𝗿𝗶𝗰𝗮 𝗶𝗻 𝘁𝘂𝗹𝗯𝘂𝗿𝗮𝗿𝗶𝗹𝗲 𝗱𝗲 𝗱𝗲𝘇𝘃𝗼𝗹𝘁𝗮𝗿𝗲 𝗹𝗮 𝗰𝗼𝗽𝗶𝗶"
            />

            <CarouselComp
              photo="/images/articol logopedie 3.png"
              alt="Particularitatile de limbaj in tulburarea de spectru autist, Asociatia PsiNapsis"
              goTo="/articles/logopedyarticle"
              titluArticol="Particularitatile de limbaj in tulburarea de spectru autist"
            />
            <CarouselComp
              photo="/images/art_autism.png"
              alt="Autism, Terapia de recuperare, Asociatia PsiNapsis"
              goTo="/articles/recovertherapyarticle"
              titluArticol="Terapia de recuperare in autism. Intrebari si clarificari"
            />

            <CarouselComp
              photo="/images/neurodiversity.jpg"
              alt="Umbrela neurodiversitatii, Asociatia PsiNapsis"
              goTo="/articles/neurodiversityarticle"
              titluArticol="Neurodivergenta"
            />

          </Carousel>
        </Col>
        <Col className="d-none d-xl-block"></Col>
      </Row>
    </>
  );
}
